export default __webpack_public_path__ + "static/media/ETC.4be2b394.jpg";